__turbopack_context__.v({
  "picture": "index-module-scss-module__QXPZKq__picture",
  "presence_online_status": "index-module-scss-module__QXPZKq__presence_online_status",
  "rounded_user_badge": "index-module-scss-module__QXPZKq__rounded_user_badge",
  "small": "index-module-scss-module__QXPZKq__small",
});
